import BaseScene from "../../scenes/BaseScene";

export default class ScoreTimer extends Phaser.GameObjects.Container {
  background: Phaser.GameObjects.Image;
  value: number = 0;
  valueDisplay: Phaser.GameObjects.Text;

  constructor(scene: BaseScene, x: number, y: number) {
    super(scene, x, y);

    this.background = scene.add.image(-10, 0, "runner-atlas", "hub-fill-left.png");

    this.valueDisplay = scene.add.text(
      0-20,
      0,
      "0",
      scene.sponge.data.model.fonts.timer
    );

    this.valueDisplay.setOrigin(0.5);

    this.add([this.background, this.valueDisplay]);

    scene.add.existing(this);
  }

  reset() {
    this.value = 0;
    this.valueDisplay.setText("0");
  }

  update() {
    super.update();
    this.valueDisplay.setText("" + Math.floor(this.value));
  }
}
